import { useCallback, useEffect, useState } from 'react'

export type AdminTheme = 'dark' | 'light'

const STORAGE_KEY = 'lv-admin-theme'
const EVENT = 'lv-admin-theme-change'

/** Læser det valgte tema. Det er kun en visningspræference på denne enhed — ingen data. */
export function readAdminTheme(): AdminTheme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark'
  } catch {
    return 'dark'
  }
}

export function adminThemeClass(theme: AdminTheme): string {
  return theme === 'light' ? 'admin-light' : 'admin-dark'
}

/** Lys/mørk tilstand for admin-området. Den offentlige hjemmeside påvirkes ikke. */
export function useAdminTheme() {
  const [theme, setThemeState] = useState<AdminTheme>(readAdminTheme)

  useEffect(() => {
    const sync = () => setThemeState(readAdminTheme())
    window.addEventListener(EVENT, sync)
    window.addEventListener('storage', sync)
    return () => {
      window.removeEventListener(EVENT, sync)
      window.removeEventListener('storage', sync)
    }
  }, [])

  const setTheme = useCallback((next: AdminTheme) => {
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch {
      // Kan præferencen ikke gemmes, skifter vi stadig for denne visning.
    }
    setThemeState(next)
    window.dispatchEvent(new Event(EVENT))
  }, [])

  const toggle = useCallback(() => setTheme(theme === 'dark' ? 'light' : 'dark'), [theme, setTheme])

  return { theme, setTheme, toggle }
}
